export const COLORS = {
  PRIMARY: "#262260",
  INDIGO_LIGHT: "#B1B1E1",
  INDIGO_MEDIUM: "#6A6891",
  PURPLE_FULL: "#CD8DE5",
  WHITE: "#FFFFFF",
};
